import React from 'react';
import { useDialog } from '@ianesthesie-kit/redux';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { TranslatedText, useRouterPush } from '@ianesthesie-kit/core';
import { ZeroPaddingDialogContainer } from './common';

const toKey = (tail: string) => `patient-app.error.noPendingPatient.${tail}`;

export const PendingPatientNotFoundDialog = () => {
  const { closeDialog } = useDialog();
  const push = useRouterPush();

  const closeAndRedirect = () => () => {
    closeDialog();
    push('/auth/login');
  };

  return (
    <ZeroPaddingDialogContainer>
      <DialogTitle>
        <TranslatedText id={toKey('title')} />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <TranslatedText id={toKey('body1')} />
          <br />
          <br />
          <TranslatedText id={toKey('body2')} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeAndRedirect()}>
          <TranslatedText id="app.ok" />
        </Button>
      </DialogActions>
    </ZeroPaddingDialogContainer>
  );
};
